const CANDLES = [
  'None',
  'Ocean',
  'Rose',
  'Shea Butter',
];

export default CANDLES;
